module.exports = __webpack_public_path__ + "static/media/17.9131168f.png";